import {Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import {pricingData} from "../../util/PricingData";
import React from "react";

export function PricingTable() {
    return <Table>
        <TableHead>
            <TableRow>
                <TableCell>Variant</TableCell>
                <TableCell align="right">Price (in euros) </TableCell>
                <TableCell align="right">Description</TableCell>

            </TableRow>
        </TableHead>
        <TableBody>
            {pricingData.map(d =>
                <TableRow>
                    <TableCell> {d.variant} </TableCell>
                    <TableCell align="right"> € {d.price} </TableCell>
                    <TableCell align="right"> {d.description} </TableCell>
                </TableRow>
            )}
        </TableBody>
    </Table>;
}